import * as actions from '../redux/actions';

import React, { Component, useEffect, useState } from 'react';

import CommonService from '../../../../services/commonService';
import DateService from '../../../../services/dateService';
import PropTypes from 'prop-types';
import { SvgHome } from '../../../common';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

function PaymentRightSideBar({
  pbServiceList,
  home,
  pbPaymentDetails,
  actions,
  walletMoneyAdded,
  virtualMoneyAmount,
  onwardBasicFare,
  basicFare,
  originalBaseFare,
  calculateNetFare,
  calculateNetFareUSD,
  promoCode,
  promoCouponAmount,
  t,
  showUsd,
  onPromoRemove,
  corporateDiscountState,
  instantDiscount,
  pullmanDiscountApplied,
  ftmDiscount,
  test,
  is_mot,
  motData,
}) {
  console.log('PaymentRightSidebar props---', basicFare());
  let countrieCodes = [];
  let paymentGatewayList;
  let idCardTypes = [];

  const [mobileError, setMobileError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [confirmEmailError, setConfirmEmailError] = useState(null);
  const [selectedPaymentGateway, setSelectedPaymentGateway] = useState(null);
  const [showBookingConfirmModal, setShowBookingConfirmModal] = useState(false);
  const [wallet, setWallet] = useState(false);
  const [walletMoney, setWalletMoney] = useState(0);
  const [confirmTabSelected, setConfirmTabSelected] = useState(1);
  const [selectSeatsOnward, setSelectSeatsOnward] = useState([]);
  const [selectSeatsReturn, setSelectSeatsReturn] = useState([]);
  const [journeyTypeActive, setJourneyTypeActive] = useState(1);
  const [discountApplied, setDiscountApplied] = useState(0);
  const [discountAppliedFlag, setDiscountAppliedFlag] = useState(0);

  const isTSService =
    sessionStorage.getItem('isTSService') && sessionStorage.getItem('isTSService') === 'true'
      ? true
      : false;
  const isTSServiceRound =
    sessionStorage.getItem('isTSServiceRound') &&
    sessionStorage.getItem('isTSServiceRound') === 'true'
      ? true
      : false;

  const isInstanteFixedAmount = instantDiscount ? instantDiscount.is_fixed_amount : false;

  // COMPONENT DID MOUNT
  useEffect(() => {
    if (
      pbServiceList.bookingDetailsOnward &&
      pbServiceList.bookingDetailsOnward.selectedSeatsToBook
    ) {
      setSelectSeatsOnward(
        seatTypesFrequeny(pbServiceList.bookingDetailsOnward.selectedSeatsToBook),
      );
    }
    if (
      pbServiceList.bookingDetailsReturn &&
      pbServiceList.bookingDetailsReturn.selectedSeatsToBook
    ) {
      setSelectSeatsReturn(
        seatTypesFrequeny(pbServiceList.bookingDetailsReturn.selectedSeatsToBook),
      );
    }
  }, []);

  // COMPONENT DID UPDATE
  useEffect(() => {
    if (home.metaData && home.metaData.country_codes)
      for (let c of home.metaData.country_codes) {
        countrieCodes.push({
          id: c,
          name: '+' + c,
        });
      }
    paymentGatewayList = CommonService.copyObject(
      home.metaData &&
        home.metaData.payment_gate_way_list_v1 &&
        home.metaData.payment_gate_way_list_v1,
    );
  });

  const seatTypesFrequeny = arr => {
    var a = [],
      b = [],
      c = [],
      prev = {};

    // prev = arr[0];

    arr.sort((a, b) => {
      if (a.fare > b.fare) return 1;
      if (b.fare > a.fare) return -1;

      return 0;
    });
    // for (var i = 0; i < arr.length; i++) {
    //   if (prev && arr[i].type !== prev.type) {
    //     a.push(arr[i]);
    //     b.push(1);
    //   } else {
    //     b[b.length - 1]++;

    //   }
    //   prev = arr[i];
    // }

    // return [a, b];

    let arr2 = [];

    arr.map(val => {
      if (!val.is_pet_seat) {
        arr2.push({ is_pet_seat: false, ...val });
      } else {
        arr2.push(val);
      }
    });

    arr2.sort((a, b) => {
      if (a.is_pet_seat > b.is_pet_seat) return 1;
      if (b.is_pet_seat > a.is_pet_seat) return -1;

      return 0;
    });

    for (var i = 0; i < arr2.length; i++) {
      if (prev && arr2[i].type !== prev.type) {
        a.push(arr2[i]);
        b.push(1);
      } else {
        if (arr2[i].is_pet_seat !== prev.is_pet_seat) {
          a.push(arr2[i]);
          b.push(1);
        } else {
          b[b.length - 1]++;
        }
      }

      prev = arr2[i];
    }

    return [a, b];
  };

  const renderSummaryDetailsCard = (service, date, source, dest, title) => {
    return (
      <div className="summary-details">
        <div className="op-name light-text font10">
          {service.route ? service.route.operator_service_name : ''}
        </div>
        {date ? (
          <span className="date font10">
            {DateService.getDayNameFromDate(date) +
              ', ' +
              DateService.getDateFromDate(date) +
              ' ' +
              DateService.getMonthNameFromDate(date) +
              ', ' +
              DateService.getYearFromDate(date)}
          </span>
        ) : null}
        <div className="location-details">
          <div className="city-name font11 bold-text">
            <img
              className="icon-source"
              src="/images/search-bar/search-bar-origin.svg"
              alt={t('TRANSLATIONS.ICON_SOURCE')}
            />
            <span className="font11">{source ? source.label : ''}</span>
          </div>
          <div className="address light-text font10">
            {service.boardingStage
              ? (service.boardingStage.name
                  ? service.boardingStage.name
                  : service.boardingStage.landmark) + '. '
              : ''}
            {service.boardingStage ? (
              <span>{DateService.ampm(service.boardingStage.time)}</span>
            ) : null}
          </div>
        </div>
        <div className="location-details">
          <div className="city-name font11 bold-text">
            <img className="icon-dest" src="/images/search-bar/search-bar-destination.svg" />
            <span className="font11">{dest ? dest.label : ''}</span>
          </div>
          <div className="address light-text font10">
            {service.droppingStage
              ? (service.droppingStage.name
                  ? service.droppingStage.name
                  : service.droppingStage.landmark) + '. '
              : ''}
            {service.boardingStage ? (
              <span>{DateService.ampm(service.droppingStage.time)}</span>
            ) : null}
          </div>
        </div>
        {service.route ? (
          <div className="duration light-text font10">
            <img className="icon-source" src="/images/icons/icon_duration.svg" />
            <span>{t('PASSENGER_DETAILS.DURATION')} : </span> &nbsp;
            <span className="time">
              {service.route.duration}&nbsp;
              <span className="hours">{t('RESULTS_PAGE.HOURS')}</span>
            </span>
          </div>
        ) : null}
      </div>
    );
  };

  const calculateMotDiscount = (selectSeatsOnward, motData) => {
    let fareAmount = Number(
      isTSService ? selectSeatsOnward[0][0].fare : selectSeatsOnward[0][0].o_fare,
    );
    let fareAfterDiscount = fareAmount - Number(motData.mot_amount);
    return fareAfterDiscount;
  };

  const renderDiscount = () => {
    console.log('Testing instantDiscount----', instantDiscount);

    let corporateName = corporateDiscountState && corporateDiscountState.name;
    let instantName = instantDiscount && instantDiscount.name;

    let corporateAmount = corporateDiscountState && corporateDiscountState.discount_amount;
    let instantAmount = instantDiscount && instantDiscount.discount_amount;

    let corporateType =
      corporateDiscountState && corporateDiscountState.type === 1
        ? t('PASSENGER_DETAILS.DISCOUNT')
        : 'Cashback';
    let instantType =
      instantDiscount && instantDiscount.type === 1 ? t('PASSENGER_DETAILS.DISCOUNT') : 'Cashback';

    let pullmanDiscount = pullmanDiscountApplied ? pullmanDiscountApplied.op_total_discount : 0;

    let smartMilesDataDiscount = +(ftmDiscount && ftmDiscount.total_redemption_amount
      ? ftmDiscount.total_redemption_amount
      : 0);
    smartMilesDataDiscount =
      smartMilesDataDiscount > onwardBasicFare() ? onwardBasicFare() : smartMilesDataDiscount;

    let discountToApply = Math.max(
      corporateAmount || 0,
      instantAmount || 0,
      pullmanDiscount || 0,
      (isInstanteFixedAmount ? 0 : smartMilesDataDiscount) || 0,
    );

    const returnArray = [];

    if (
      (discountToApply <= smartMilesDataDiscount || isInstanteFixedAmount) &&
      smartMilesDataDiscount
    ) {
      returnArray.push(
        <div className="discount-block fl ">
          <div className="discount-row flex-row">
            <div className="font10">
              <span>Descuento:</span>
              <div>FTM Descuento</div>
            </div>
            <div
              className="secondary-text font10 bold-text "
              tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
            >
              CLP {CommonService.currency(smartMilesDataDiscount).split(',')[0]}
            </div>
          </div>
        </div>,
      );
    }
    if (corporateDiscountState && instantDiscount) {
      if (!discountAppliedFlag) {
        setDiscountApplied(corporateAmount > instantAmount ? corporateAmount : instantAmount);
        setDiscountAppliedFlag(!discountAppliedFlag);
      }
      returnArray.push(
        <div className="discount-block fl ">
          <div className="discount-row flex-row">
            <div className="font10">
              <span>{instantAmount > corporateAmount ? instantType : corporateType}</span>
              <div>{instantAmount > corporateAmount ? instantName : corporateName}</div>
            </div>
            <div
              className="secondary-text font10 bold-text "
              tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
            >
              CLP{' '}
              {
                CommonService.currency(
                  corporateAmount > instantAmount ? corporateAmount : instantAmount,
                ).split(',')[0]
              }
            </div>
          </div>
        </div>,
      );
    } else if (corporateDiscountState && !instantDiscount) {
      if (!discountAppliedFlag) {
        setDiscountApplied(corporateAmount);
        setDiscountAppliedFlag(!discountAppliedFlag);
      }
      returnArray.push(
        <div className="discount-block fl ">
          <div className="discount-row flex-row">
            <div className="font10">
              <span>{corporateType}</span>
              <div> {corporateName}</div>
            </div>
            <div
              className="secondary-text font10 bold-text "
              tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
            >
              CLP {CommonService.currency(corporateAmount).split(',')[0]}
            </div>
          </div>
        </div>,
      );
    } else if (!corporateDiscountState && instantDiscount) {
      if (!discountAppliedFlag) {
        setDiscountApplied(instantAmount);
        setDiscountAppliedFlag(!discountAppliedFlag);
      }
      returnArray.push(
        <div className="discount-block fl ">
          <div className="discount-row flex-row">
            <div className="font10">
              <span>{instantType}</span>
              <div> {instantName}</div>
            </div>
            <div
              className="secondary-text font10 bold-text "
              tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
            >
              CLP {CommonService.currency(instantAmount).split(',')[0]}
            </div>
          </div>
        </div>,
      );
    } else if (pullmanDiscountApplied) {
      if (!discountAppliedFlag) {
        setDiscountApplied(pullmanDiscountApplied.op_total_discount);
        setDiscountAppliedFlag(!discountAppliedFlag);
      }
      returnArray.push(
        <div className="discount-block fl ">
          <div className="discount-row flex-row">
            <div className="font10">
              <span>{t('PASSENGER_DETAILS.DISCOUNT')}</span>
              {/* <div> {instantName}</div> */}
            </div>
            <div
              className="secondary-text font10 bold-text "
              style={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
            >
              CLP {CommonService.currency(pullmanDiscountApplied.op_total_discount).split(',')[0]}
            </div>
          </div>
        </div>,
      );
    } else if (is_mot && motData) {
      // if (!discountAppliedFlag) {
      //   setDiscountApplied(pullmanDiscountApplied.op_total_discount);
      //   setDiscountAppliedFlag(!discountAppliedFlag);
      // }
      returnArray.push(
        <div className="discount-block fl ">
          <div className="discount-row flex-row">
            <div className="font10">
              {/* <span>{t('PASSENGER_DETAILS.DISCOUNT')}</span> */}
              <div className="font10 bold-text mb-1">{t('PASSENGER_DETAILS.MOT_DISCOUNT')}</div>
              <div className="font8 grey-text">{motData.mot_code}</div>
            </div>
            <div
              className="secondary-text font10 bold-text "
              tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
            >
              {/* {calculateMotDiscount(selectSeatsOnward, motData)} */}
              CLP {CommonService.currency(calculateMotDiscount(selectSeatsOnward, motData))}
            </div>
          </div>

          <div className="discount-row flex-row mt-2">
            <div className="font10">
              {/* <span>{t('PASSENGER_DETAILS.DISCOUNT')}</span> */}
              <div className="font10 bold-text">{t('PASSENGER_DETAILS.MOT_COUPON_AMOUNT')}</div>
            </div>
            <div
              className="secondary-text font10 bold-text "
              tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
            >
              {/* {calculateMotDiscount(selectSeatsOnward, motData)} */}
              CLP {CommonService.currency(motData.mot_amount)}
            </div>
          </div>
        </div>,
      );
    }

    return returnArray;
  };

  const getBaseDiscount = () => {
    let baseDiscount = originalBaseFare() - basicFare();

    if (baseDiscount > 0) {
      return baseDiscount;
    } else {
      return pbServiceList && pbServiceList.bookingDetailsOnward
        ? CommonService.currency(pbServiceList.bookingDetailsOnward.discountAmount).split(',')[0]
        : '';
    }
  };

  const getPullmanPayAmount = () => {
    let corporateAmount = corporateDiscountState ? corporateDiscountState.discount_amount : 0;
    let instantAmount = instantDiscount ? instantDiscount.discount_amount : 0;
    let baseDiscount = getBaseDiscount();
    let pullmanDiscount = pullmanDiscountApplied ? pullmanDiscountApplied.op_total_discount : 0;

    let smartMilesDataDiscount = +(this.props.ftmDiscount &&
    this.props.ftmDiscount.total_redemption_amount
      ? this.props.ftmDiscount.total_redemption_amount
      : 0);

    let discountToApply = Math.max(
      corporateAmount || 0,
      instantAmount || 0,
      pullmanDiscount || 0,
      (isInstanteFixedAmount ? 0 : smartMilesDataDiscount) || 0,
    );
    return (
      originalBaseFare() - discountToApply - (isInstanteFixedAmount ? smartMilesDataDiscount : 0)
    );
  };

  let selectedServiceOnward =
    pbServiceList && pbServiceList.selectedServiceOnward ? pbServiceList.selectedServiceOnward : {};
  let onwardPBDate = home ? home.onwardPBDate : null;
  let destCityOnward = home ? home.pbDestinationCity : null;
  let sourceCityOnward = home ? home.pbSourceCity : null;

  let selectedServiceReturn =
    pbServiceList && pbServiceList.selectedServiceReturn ? pbServiceList.selectedServiceReturn : {};
  let returnPBDate = home ? home.returnPBDate : null;
  let sourceCityReturn = home ? home.pbDestinationCity : null;
  let destCityReturn = home ? home.pbSourceCity : null;

  return (
    <div className="pb-payment-details-payment-right-side-bar journey-summary-sidebar">
      <div className="kupos-card">
        <div>
          <div className="summary-title bold-text font13">
            {t('PASSENGER_DETAILS.SUMMARY')}{' '}
            <span className="bold-text"> {t('PASSENGER_DETAILS.SUMMARY_BOLD')}</span>
            <span className="yellow-line"></span>
          </div>

          <div className={'journey-date ' + (!returnPBDate ? 'flex-row' : '')}>
            <div className={'switch-buttons font10 ' + (returnPBDate ? 'rt' : '')}>
              <span
                className={'switch-item ' + (journeyTypeActive == 1 ? 'active' : '')}
                onClick={() => setJourneyTypeActive(1)}
              >
                {t('RESULTS_PAGE.GOING')}
              </span>
              {returnPBDate ? (
                <span
                  className={'switch-item ' + (journeyTypeActive == 2 ? 'active' : '')}
                  onClick={() => setJourneyTypeActive(2)}
                >
                  {t('RESULTS_PAGE.RETURN')}
                </span>
              ) : null}
            </div>
          </div>
          {journeyTypeActive == 1
            ? renderSummaryDetailsCard(
                selectedServiceOnward,
                onwardPBDate,
                sourceCityOnward,
                destCityOnward,
                t('RESULTS_PAGE.GOING'),
              )
            : renderSummaryDetailsCard(
                selectedServiceReturn,
                returnPBDate,
                sourceCityReturn,
                destCityReturn,
                t('RESULTS_PAGE.RETURN'),
              )}
        </div>

        <div className="payment-details-sidebar">
          <div className="payment-seats">
            {pbServiceList && selectSeatsOnward && selectSeatsOnward[0]
              ? selectSeatsOnward[0].map((val, key) => {
                  console.log({ val });
                  console.log('val', isTSService);
                  return (
                    <div key={key} className="payment-seat-row flex-row font10 ">
                      <div>
                        <span>{selectSeatsOnward[1][key]}</span>
                        {' x '}
                        {val.is_pet_seat
                          ? 'Mascota a bordo'
                          : CommonService.capitalize(CommonService.getSeatName(val.type))}
                        :
                      </div>
                      <div className="bold-text">
                        CLP{' '}
                        {
                          CommonService.currency(
                            Number(val.fare) * selectSeatsOnward[1][key],
                          ).split(',')[0]
                        }
                        {/* {
                          CommonService.currency(
                            Number(isTSService ? val.fare : val.o_fare ? val.o_fare : val.fare) *
                              selectSeatsOnward[1][key],
                          ).split(',')[0]
                        } */}
                      </div>
                    </div>
                  );
                })
              : null}
            {pbServiceList && selectSeatsReturn && selectSeatsReturn[0]
              ? selectSeatsReturn[0].map((val, key) => {
                  return (
                    <div key={key} className="payment-seat-row flex-row font10">
                      <div>
                        <span>{selectSeatsReturn[1][key]}</span>
                        {' x '}
                        {val.is_pet_seat
                          ? 'Mascota a bordo'
                          : CommonService.capitalize(CommonService.getSeatName(val.type))}
                        :
                      </div>
                      <div className="bold-text">
                        CLP{' '}
                        {
                          CommonService.currency(
                            Number(val.fare) * selectSeatsReturn[1][key],
                          ).split(',')[0]
                        }
                        {/* {
                          CommonService.currency(
                            Number(isTSServiceRound ? val.fare : val.o_fare) *
                              selectSeatsReturn[1][key],
                          ).split(',')[0]
                        } */}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>

          {renderDiscount()}

          <div className="discount-block fl ">
            {!corporateDiscountState &&
              !instantDiscount &&
              !pullmanDiscountApplied &&
              !isTSService &&
              !isTSServiceRound && (
                <div className="discount-row flex-row">
                  <div className="font10">{t('PASSENGER_DETAILS.DISCOUNT')}</div>
                  <div
                    className="secondary-text font10 bold-text "
                    tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
                  >
                    CLP {CommonService.currency(getBaseDiscount())}
                  </div>
                </div>
              )}
            {pullmanDiscountApplied && (
              <div className="discount-row flex-row">
                <div className="font10">{`${pullmanDiscountApplied.convenio_name
                  .replace('["', '')
                  .replace('"]', '')}  (${pullmanDiscountApplied.disc_percent}%)`}</div>
              </div>
            )}

            <div className="discount-row flex-row">
              <div className="font10">{t('PASSENGER_DETAILS.PROMO_CODE')}</div>
              <div
                className="secondary-text font10 bold-text "
                style={{
                  minWidth: 80,
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                CLP{' '}
                {CommonService.currency(promoCouponAmount ? promoCouponAmount : 0).split(',')[0]}
              </div>
            </div>
            {promoCouponAmount ? (
              <div className="promocode font10">
                <div>{promoCode}</div>
                <span className="promo-remove" onClick={onPromoRemove}>
                  <SvgHome name="close" />
                </span>
              </div>
            ) : null}
          </div>

          {walletMoneyAdded() ? (
            <div className="subtotal-row flex-row">
              <div className="font10">PullmanPay</div>
              <div className="secondary-text font10 bold-text ">
                CLP {CommonService.currency(+walletMoneyAdded(basicFare() - discountApplied))}
              </div>
            </div>
          ) : null}

          <div className="subtotal-block font10">
            {/* <div className="subtotal-row flex-row">
              <div className="primary-text">{t('PASSENGER_DETAILS.SUB_TOTAL')}</div>
              <div className="primary-text bold">
                CLP{CommonService.currency((this.props.pbServiceList &&
                this.props.pbServiceList.bookingDetailsOnward &&
                this.props.pbServiceList.bookingDetailsOnward
                  ? this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
                  : 0) +
                  (this.props.pbServiceList &&
                  this.props.pbServiceList.bookingDetailsReturn &&
                  this.props.pbServiceList.bookingDetailsReturn
                    ? this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
                    : 0)).split(',')[0]}
              </div>
            </div> */}
            {showUsd ? (
              <div className="subtotal-row flex-row">
                <div className="primary-text">{t('PASSENGER_DETAILS.AMOUNT_IN_USD')}</div>
                <div className="primary-text bold-text ">
                  USD{CommonService.currency(+calculateNetFareUSD()).split(',')[0]}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="total bold">
        <div className="total-row flex-row font13">
          <div>Total</div>
          <div>CLP {CommonService.currency(calculateNetFare()).split(',')[0]}</div>
          {/* <div>CLP {CommonService.currency(+walletMoneyAdded(basicFare() - discountApplied))}</div> */}
        </div>
      </div>
    </div>
  );
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    pbPaymentDetails: state.pbPaymentDetails,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentRightSideBar);

// export class PaymentRightSideBar extends Component {
//   static propTypes = {
//     pbServiceList: PropTypes.object,
//     home: PropTypes.object,
//     pbPaymentDetails: PropTypes.object.isRequired,
//     actions: PropTypes.object.isRequired,

//     walletMoneyAdded: PropTypes.func,
//     virtualMoneyAmount: PropTypes.func,
//     basicFare: PropTypes.func,
//     calculateNetFare: PropTypes.func,
//     calculateNetFareUSD: PropTypes.func,
//     promoCode: PropTypes.string,
//     promoCouponAmount: PropTypes.number,
//     t: PropTypes.func,
//     showUsd: PropTypes.bool,
//     onPromoRemove: PropTypes.func,
//     corporateDiscountState: PropTypes.object,
//   };

//   countrieCodes = [];
//   paymentGatewayList;
//   idCardTypes = [];

//   constructor(props) {
//     super(props);
//     this.state = {
//       mobileError: null,
//       emailError: null,
//       confirmEmailError: null,
//       selectedPaymentGateway: null,
//       showBookingConfirmModal: false,
//       wallet: false,
//       walletMoney: 0,
//       confirmTabSelected: 1,
//       selectSeatsOnward: [],
//       selectSeatsReturn: [],
//       journeyTypeActive: 1,
//     };
//   }

//   componentWillMount() {
//     if (
//       this.props.pbServiceList.bookingDetailsOnward &&
//       this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
//     ) {
//       this.setState({
//         selectSeatsOnward: this.seatTypesFrequeny(
//           this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook,
//         ),
//       });
//     }
//     if (
//       this.props.pbServiceList.bookingDetailsReturn &&
//       this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
//     ) {
//       this.setState({
//         selectSeatsReturn: this.seatTypesFrequeny(
//           this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
//         ),
//       });
//     }
//   }

// componentDidUpdate() {
//   for (let c of this.props.home.metaData.country_codes) {
//     this.countrieCodes.push({
//       id: c,
//       name: '+' + c,
//     });
//   }
//   this.paymentGatewayList = CommonService.copyObject(
//     this.props.home.metaData.payment_gate_way_list_v1,
//   );
// }

//   seatTypesFrequeny(arr) {
//     var a = [],
//       b = [],
//       prev = {};

//     arr.sort((a, b) => {
//       if (a.fare > b.fare) return 1;
//       if (b.fare > a.fare) return -1;

//       return 0;
//     });
//     for (var i = 0; i < arr.length; i++) {
//       if (prev && arr[i].type !== prev.type) {
//         a.push(arr[i]);
//         b.push(1);
//       } else {
//         b[b.length - 1]++;
//       }
//       prev = arr[i];
//     }

//     return [a, b];
//   }

//   renderSummaryDetailsCard = (service, date, source, dest, title) => {
//     console.log('Servuice --------------------', service);
//     return (
//       <div className="summary-details">
//         <div className="op-name light-text font10">
//           {service.route ? service.route.operator_service_name : ''}
//         </div>
//         {date ? (
//           <span className="date font10">
//             {DateService.getDayNameFromDate(date) +
//               ', ' +
//               DateService.getDateFromDate(date) +
//               ' ' +
//               DateService.getMonthNameFromDate(date) +
//               ', ' +
//               DateService.getYearFromDate(date)}
//           </span>
//         ) : null}
//         <div className="location-details">
//           <div className="city-name font11 bold-text">
//             <img
//               className="icon-source"
//               src="/images/icons/home/icon_source.png"
//               alt={this.props.t('TRANSLATIONS.ICON_SOURCE')}
//             />
//             <span className="font11">{source ? source.label : ''}</span>
//           </div>
//           <div className="address light-text font10">
//             {service.boardingStage
//               ? (service.boardingStage.name
//                   ? service.boardingStage.name
//                   : service.boardingStage.landmark) + '. '
//               : ''}
//             {service.boardingStage ? (
//               <span>{DateService.ampm(service.boardingStage.time)}</span>
//             ) : null}
//           </div>
//         </div>
//         <div className="location-details">
//           <div className="city-name font11 bold-text">
//             <img className="icon-dest" src="/images/icons/home/icon_source2.png" />
//             <span className="font11">{dest ? dest.label : ''}</span>
//           </div>
//           <div className="address light-text font10">
//             {service.droppingStage
//               ? (service.droppingStage.name
//                   ? service.droppingStage.name
//                   : service.droppingStage.landmark) + '. '
//               : ''}
//             {service.boardingStage ? (
//               <span>{DateService.ampm(service.droppingStage.time)}</span>
//             ) : null}
//           </div>
//         </div>
//         {service.route ? (
//           <div className="duration light-text font10">
//             <img className="icon-source" src="/images/icons/icon_duration.svg" />
//             <span>{this.props.t('PASSENGER_DETAILS.DURATION')} : </span> &nbsp;
//             <span className="time">
//               {service.route.duration}&nbsp;
//               <span className="hours">{this.props.t('RESULTS_PAGE.HOURS')}</span>
//             </span>
//           </div>
//         ) : null}
//       </div>
//     );
//   };

//   render() {
//     const { t } = this.props;
//     let selectedServiceOnward =
//       this.props.pbServiceList && this.props.pbServiceList.selectedServiceOnward
//         ? this.props.pbServiceList.selectedServiceOnward
//         : {};
//     let onwardPBDate = this.props.home ? this.props.home.onwardPBDate : null;
//     let destCityOnward = this.props.home ? this.props.home.pbDestinationCity : null;
//     let sourceCityOnward = this.props.home ? this.props.home.pbSourceCity : null;

//     let selectedServiceReturn =
//       this.props.pbServiceList && this.props.pbServiceList.selectedServiceReturn
//         ? this.props.pbServiceList.selectedServiceReturn
//         : {};
//     let returnPBDate = this.props.home ? this.props.home.returnPBDate : null;
//     let sourceCityReturn = this.props.home ? this.props.home.pbDestinationCity : null;
//     let destCityReturn = this.props.home ? this.props.home.pbSourceCity : null;
//     return (
//       <div className="pb-payment-details-payment-right-side-bar journey-summary-sidebar">
//         <div className="kupos-card">
//           <div>
//             <div className="summary-title font13">
//               {t('PASSENGER_DETAILS.SUMMARY')}{' '}
//               <span className="bold-text"> {t('PASSENGER_DETAILS.SUMMARY_BOLD')}</span>
//             </div>

//             <div className={'journey-date ' + (!returnPBDate ? 'flex-row' : '')}>
//               <div className={'switch-buttons font10 ' + (returnPBDate ? 'rt' : '')}>
//                 <span
//                   className={'switch-item ' + (this.state.journeyTypeActive == 1 ? 'active' : '')}
//                   onClick={() => this.setState({ journeyTypeActive: 1 })}
//                 >
//                   {t('RESULTS_PAGE.GOING')}
//                 </span>
//                 {returnPBDate ? (
//                   <span
//                     className={'switch-item ' + (this.state.journeyTypeActive == 2 ? 'active' : '')}
//                     onClick={() => this.setState({ journeyTypeActive: 2 })}
//                   >
//                     {t('RESULTS_PAGE.RETURN')}
//                   </span>
//                 ) : null}
//               </div>
//             </div>
//             {this.state.journeyTypeActive == 1
//               ? this.renderSummaryDetailsCard(
//                   selectedServiceOnward,
//                   onwardPBDate,
//                   sourceCityOnward,
//                   destCityOnward,
//                   t('RESULTS_PAGE.GOING'),
//                 )
//               : this.renderSummaryDetailsCard(
//                   selectedServiceReturn,
//                   returnPBDate,
//                   sourceCityReturn,
//                   destCityReturn,
//                   t('RESULTS_PAGE.RETURN'),
//                 )}
//           </div>

//           <div className="payment-details-sidebar">
//             {/* <div className="payment-sidebar-title font13">
//               {t('PASSENGER_DETAILS.PAYMENT_DETAILS.NORMAL')}{' '}
//               <span className="bold">{t('PASSENGER_DETAILS.PAYMENT_DETAILS.BOLD')}</span>
//             </div> */}
//             <div className="payment-seats">
//               {/* <div className="font12">{t('PASSENGER_DETAILS.SEATS')}</div> */}
//               {this.props.pbServiceList &&
//               this.state.selectSeatsOnward &&
//               this.state.selectSeatsOnward[0]
//                 ? this.state.selectSeatsOnward[0].map((val, key) => {
//                     return (
//                       <div key={key} className="payment-seat-row flex-row font10 ">
//                         <div>
//                           <span>{this.state.selectSeatsOnward[1][key]}</span>
//                           {' x '}
//                           {CommonService.capitalize(CommonService.getSeatName(val.type))}:
//                         </div>
//                         <div className="bold-text">
//                           CLP{' '}
//                           {
//                             CommonService.currency(
//                               val.net_amount * this.state.selectSeatsOnward[1][key],
//                             ).split(',')[0]
//                           }
//                         </div>
//                       </div>
//                     );
//                   })
//                 : null}
//               {this.props.pbServiceList &&
//               this.state.selectSeatsReturn &&
//               this.state.selectSeatsReturn[0]
//                 ? this.state.selectSeatsReturn[0].map((val, key) => {
//                     return (
//                       <div key={key} className="payment-seat-row flex-row font10">
//                         <div>
//                           <span>{this.state.selectSeatsReturn[1][key]}</span>
//                           {' x '}
//                           {CommonService.capitalize(CommonService.getSeatName(val.type))}:
//                         </div>
//                         <div className="bold-text">
//                           CLP{' '}
//                           {
//                             CommonService.currency(
//                               val.net_amount * this.state.selectSeatsReturn[1][key],
//                             ).split(',')[0]
//                           }
//                         </div>
//                       </div>
//                     );
//                   })
//                 : null}
//             </div>

//             {this.props.corporateDiscountState && (
//               <div className="discount-block fl ">
//                 <div className="discount-row flex-row">
//                   <div className="font10">
//                     <span>
//                       {this.props.corporateDiscountState.type === 1
//                         ? t('PASSENGER_DETAILS.DISCOUNT')
//                         : 'Cashback'}
//                     </span>
//                     <div>{this.props.corporateDiscountState.name}</div>
//                   </div>
//                   <div
//                     className="secondary-text font10 bold-text "
//                     tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
//                   >
//                     CLP{' '}
//                     {
//                       CommonService.currency(
//                         this.props.corporateDiscountState.discount_amount,
//                       ).split(',')[0]
//                     }
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div className="discount-block fl ">
//               {!this.props.corporateDiscountState && (
//                 <div className="discount-row flex-row">
//                   <div className="font10">{t('PASSENGER_DETAILS.DISCOUNT')}</div>
//                   <div
//                     className="secondary-text font10 bold-text "
//                     tyle={{ minWidth: 80, display: 'flex', justifyContent: 'flex-end' }}
//                   >
//                     CLP{' '}
//                     {this.props.pbServiceList &&
//                     this.props.pbServiceList.bookingDetailsOnward &&
//                     this.props.pbServiceList.bookingDetailsOnward
//                       ? CommonService.currency(
//                           this.props.pbServiceList.bookingDetailsOnward.discountAmount,
//                         ).split(',')[0]
//                       : ''}
//                   </div>
//                 </div>
//               )}
//               <div className="discount-row flex-row">
//                 <div className="font10">{t('PASSENGER_DETAILS.PROMO_CODE')}</div>
//                 <div
//                   className="secondary-text font10 bold-text "
//                   style={{
//                     minWidth: 80,
//                     display: 'flex',
//                     justifyContent: 'flex-end',
//                     alignItems: 'center',
//                   }}
//                 >
//                   CLP{' '}
//                   {
//                     CommonService.currency(
//                       this.props.promoCouponAmount ? this.props.promoCouponAmount : 0,
//                     ).split(',')[0]
//                   }
//                 </div>
//               </div>
//               {this.props.promoCouponAmount ? (
//                 <div className="promocode font10">
//                   <div>{this.props.promoCode}</div>
//                   <span className="promo-remove" onClick={this.props.onPromoRemove}>
//                     <SvgHome name="close" />
//                   </span>
//                 </div>
//               ) : null}
//             </div>

//             {this.props.walletMoneyAdded() ? (
//               <div className="subtotal-row flex-row">
//                 <div className="font10">KuposPay</div>
//                 <div className="secondary-text font10 bold-text ">
//                   CLP {CommonService.currency(+this.props.walletMoneyAdded(this.props.basicFare()))}
//                 </div>
//               </div>
//             ) : null}

//             <div className="subtotal-block font10">
//               {/* <div className="subtotal-row flex-row">
//                 <div className="primary-text">{t('PASSENGER_DETAILS.SUB_TOTAL')}</div>
//                 <div className="primary-text bold">
//                   CLP{CommonService.currency((this.props.pbServiceList &&
//                   this.props.pbServiceList.bookingDetailsOnward &&
//                   this.props.pbServiceList.bookingDetailsOnward
//                     ? this.props.pbServiceList.bookingDetailsOnward.totalBookingAmount
//                     : 0) +
//                     (this.props.pbServiceList &&
//                     this.props.pbServiceList.bookingDetailsReturn &&
//                     this.props.pbServiceList.bookingDetailsReturn
//                       ? this.props.pbServiceList.bookingDetailsReturn.totalBookingAmount
//                       : 0)).split(',')[0]}
//                 </div>
//               </div> */}
//               {this.props.showUsd ? (
//                 <div className="subtotal-row flex-row">
//                   <div className="primary-text">{t('PASSENGER_DETAILS.AMOUNT_IN_USD')}</div>
//                   <div className="primary-text bold-text ">
//                     USD{CommonService.currency(+this.props.calculateNetFareUSD()).split(',')[0]}
//                   </div>
//                 </div>
//               ) : null}
//             </div>
//           </div>
//         </div>
//         <div className="total bold">
//           <div className="total-row flex-row font13">
//             <div>Total</div>
//             <div>CLP {CommonService.currency(+this.props.calculateNetFare()).split(',')[0]}</div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/PaymentRightSideBar/PaymentRightSideBar.js